import React, { Fragment, PureComponent } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { FormGroup, Input, Label } from "reactstrap";
import { withRouter } from "react-router-dom";
import { withCookies } from "react-cookie";

import { Form } from "./style";
import { Link, Text, LinkExternal } from "../../assets/styles/components";

import ContentBox from "../../components/ContentBox";
import Submit from "../../components/Submit";

import { Creators as SignupCreators } from "../../store/ducks/signup";

class Signup extends PureComponent {
  submitHandle = (e, signup) => {
    e.preventDefault();

    const voucher =
      typeof e.target.voucher !== "undefined"
        ? e.target.voucher.value.trim()
        : null;

    signup(
      e.target.nickname.value.trim(),
      e.target.email.value.trim(),
      e.target.password.value.trim(),
      e.target.mkt.value,
      voucher
    );
  };

  componentWillMount = () => {
    const { cookies } = this.props;
    cookies.set("campaign", window.location.search.replace("?campaign=", ""));
  };

  render() {
    const { baseUrl, loading, signup, match } = this.props;

    return (
      <Fragment>
        <ContentBox title="Falta pouco!">
          <Form
            accept-charset="UTF-8"
            onSubmit={e => this.submitHandle(e, signup)}
          >
            <FormGroup>
              <Input
                placeholder="Como gostaria de ser chamado"
                name="nickname"
                required
              />
            </FormGroup>
            <FormGroup>
              <Input placeholder="Email" type="email" name="email" required />
            </FormGroup>
            <FormGroup>
              <Input
                placeholder="Senha"
                type="password"
                name="password"
                required
              />
            </FormGroup>
            {match.params.voucher && (
              <FormGroup>
                <Input placeholder="Voucher" type="text" name="voucher" defaultValue={new URLSearchParams(window.location.search).get('code')} />
              </FormGroup>
            )}
            <FormGroup check>
              <Label check>
                <Input type="checkbox" value="1" name="mkt" defaultChecked />{" "}
                Desejo receber ofertas de produtos e serviços.
              </Label>
            </FormGroup>
            <Submit loading={loading} name="Cadastrar" />
          </Form>
          <Text className="linkClean">
            Ao seu cadastrar você aceita os{" "}
            <LinkExternal
              href={`${baseUrl}/termosDeUso`}
              target="_blank"
              className="mt-3"
            >
              Termos de Uso.
            </LinkExternal>
          </Text>
          <br />
          <Text className="linkClean">
            Já possui uma conta?{" "}
            <Link to={`/signin${window.location.search}`}>Faça Login</Link>
          </Text>
        </ContentBox>
      </Fragment>
    );
  }
}

const mapStateToProps = state => ({
  loading: state.signup.loading,
  baseUrl: state.sites.data.base_url
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(SignupCreators, dispatch);

export default withCookies(
  withRouter(connect(mapStateToProps, mapDispatchToProps)(Signup))
);



// WEBPACK FOOTER //
// ./src/pages/signup/index.js